module.exports = __webpack_public_path__ + "img/caret-up.c7779c68.svg";